import React from 'react';

const ContinuousGradientTitle = () => {
  const title = 'SynaptopathyDB';

  return (
    <div className="rounded-lg text-center">
      <h1 className="text-5xl md:text-7xl font-extrabold leading-relaxed pb-4 mb-4 bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-500 bg-clip-text text-transparent inline-block">
        {title}
      </h1>

      <div className="h-1 w-full max-w-xs bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-500 rounded-full mx-auto" />

      <p className="mt-4 text-lg md:text-2xl font-medium text-gray-700">
        A Comprehensive Resource for Synaptopathy Research
      </p>
    </div>
  );
};

export default ContinuousGradientTitle;
